export enum NatureAffaire {
	Article15 = 'A15',
	VoiesExecution = 'VE',
	PlacementAvecIban = 'PL',
	PlacementSansIban = 'PL2',
	ChangementBanque ='CB'
}

export enum LibellePartie1 {
	None = 'none',
	Clients = 'clients',
	Vendeurs = 'vendeurs',
	Creanciers = 'creanciers',
	ProduitPlacement = 'produitPlacement',
	CompteBancaireOrigine ='compteBancaireOrigine'
}

export enum LibellePartie2 {
	None = 'none',
	Adversaires = 'adversaires',
	Acquereurs = 'acquereurs',
	Debiteurs = 'debiteurs',
	IBANComptePlacement = 'ibanComptePlacement',
	CompteBancaireCible ='compteBancaireCible'
}

export enum DegreRisqueValeur {
	Faible = 200,
	Moyen = 500,
	Fort = 800,
	TresFort = 1000
}
